import dayjs, { type Dayjs } from 'dayjs';

export type PeriodPresetKey = 'this_month' | 'last_month' | 'this_quarter' | 'last_quarter' | 'ytd' | 'last_year' | 'last_12' | 'custom';

export const PERIOD_PRESETS: Array<{ value: PeriodPresetKey; label: string }> = [
  { value: 'this_month', label: 'This month' },
  { value: 'last_month', label: 'Last month' },
  { value: 'this_quarter', label: 'This quarter' },
  { value: 'last_quarter', label: 'Last quarter' },
  { value: 'ytd', label: 'Year to date' },
  { value: 'last_year', label: 'Last year' },
  { value: 'last_12', label: 'Last 12 months' },
  { value: 'custom', label: 'Custom' },
];

export function presetRange(key: PeriodPresetKey): [Dayjs, Dayjs] | null {
  const today = dayjs();
  const quarterStart = (d: Dayjs) => d.month(Math.floor(d.month() / 3) * 3).startOf('month');
  switch (key) {
    case 'this_month':
      return [today.startOf('month'), today];
    case 'last_month': {
      const m = today.subtract(1, 'month');
      return [m.startOf('month'), m.endOf('month')];
    }
    case 'this_quarter':
      return [quarterStart(today), today];
    case 'last_quarter': {
      const start = quarterStart(today).subtract(3, 'month');
      return [start, start.add(2, 'month').endOf('month')];
    }
    case 'ytd':
      return [today.startOf('year'), today];
    case 'last_year': {
      const y = today.subtract(1, 'year');
      return [y.startOf('year'), y.endOf('year')];
    }
    case 'last_12':
      return [today.subtract(12, 'month').add(1, 'day'), today];
    default:
      return null;
  }
}

export const isoDate = (d: Dayjs) => d.format('YYYY-MM-DD');
